import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

export const DIALOG_TYPE = 'DELETE_PLANNED_SPENDING_DIALOG';

export const deletePlannedSpendingDialog = createAction(
  rootUiActions.createDialog.toString(),
  (filterId: string, freeToSpendId: string, dialogId: string, deleteSeries: boolean) =>
    rootUiTypes.mkRootUiData({
      id: 'delete-planned-dialog',
      type: DIALOG_TYPE,
      allowNesting: true,
      props: ImmutableMap({ filterId, freeToSpendId, dialogId, deleteSeries }),
    }),
);
